export default "__VITE_ASSET__46Y3bS2g__"